import angular from 'angular';
import HttpInterceptor from './http.interceptor';

const interceptorsModule = angular.module('tinaba.interceptors', [
  HttpInterceptor.name
]);

export default interceptorsModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/interceptors/interceptors.js
 **/